export const DEFAULT_VALUE_EDITOR =
  '<div class="editor-lexical__paragraph"><br></div>';
